export const BEEKEEPER_FORMS = 'forms_management';
export const BEEKEEPER_FORMS_LITE = 'forms_lite';
